import { IObservationPayload, IObservationResponse } from './sharedTypes'
import type { CamelCasedPropertiesDeep } from 'type-fest'

export type EditObservation = (
  feedId: string,
  payload: IObservationPayload
) => Promise<CamelCasedPropertiesDeep<IObservationResponse>>
